import _ from 'lodash'

import Coupon from './coupon'

export default class CouponPage {
  constructor(
    public readonly brandEnglishName: string,
    public readonly brandName: string,
    public readonly pageNumber: number,
    public readonly coupons: Coupon[],
    public readonly limit: number
  ) {}

  get shouldShowNoItemMessage(): boolean {
    if (this.brandEnglishName === '') {
      return false
    }

    if (!this.empty) {
      return false
    }

    return true
  }

  get empty(): boolean {
    return !this.hasBrandCoupons && !this.hasCommonCoupons
  }

  get hasCommonCoupons(): boolean {
    return this.commonCoupons.length > 0
  }

  get hasBrandCoupons(): boolean {
    return this.brandCoupons.length > 0
  }

  get commonCoupons(): Coupon[] {
    return _.filter(this.coupons, (c) => {
      return c.isCommonCoupon
    })
  }

  get brandCoupons(): Coupon[] {
    return _.filter(this.coupons, (c) => {
      return c.isBrandCoupon
    })
  }

  get isFulfilled(): boolean {
    return this.coupons.length >= this.limit
  }
}

export const emptyCouponPage
  = new CouponPage('', '', 1, [], 1)
